import { APPLICATION_STATUS } from "../enums/applicationStatusEnum";
import { APPLICATION_STATUS_VALUE_FILTER } from "../enums/applicationStatusFilterValueEnum";
import { APPLICATION_STATUS_ID } from "../enums/applicationStatusIdEnum";
import { IFilter } from "../interfaces/IFilter";

export const STATUSES_TO_FILTER_AGENT: IFilter[] = [
  {
    id: APPLICATION_STATUS_ID.STATUS_REJECTED,
    label: APPLICATION_STATUS.STATUS_REJECTED,
    value: APPLICATION_STATUS_VALUE_FILTER.REJECTED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_AWAITING_ISSUANCE,
    label: APPLICATION_STATUS.STATUS_AWAITING_ISSUANCE,
    value: APPLICATION_STATUS_VALUE_FILTER.AWAITING_ISSUE,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PROPOSAL,
    label: APPLICATION_STATUS.STATUS_PROPOSAL,
    value: APPLICATION_STATUS_VALUE_FILTER.OFFER,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_SIGNATURE_REQUIRED,
    label: APPLICATION_STATUS.STATUS_SIGNATURE_REQUIRED,
    value: APPLICATION_STATUS_VALUE_FILTER.SIGNATURE_REQUIRED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PAYMENT_REQUIRED,
    label: APPLICATION_STATUS.STATUS_PAYMENT_REQUIRED,
    value: APPLICATION_STATUS_VALUE_FILTER.PAYMENT_REQUIRED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_UNDER_REVIEW,
    label: APPLICATION_STATUS.STATUS_UNDER_REVIEW,
    value: APPLICATION_STATUS_VALUE_FILTER.UNDER_REVIEW,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RETURNED_FOR_REVISION,
    label: APPLICATION_STATUS.STATUS_RETURNED_FOR_REVISION,
    value: APPLICATION_STATUS_VALUE_FILTER.REVISION,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RELEASED,
    label: APPLICATION_STATUS.STATUS_RELEASED,
    value: APPLICATION_STATUS_VALUE_FILTER.ISSUE,
  },
];

export const STATUSES_TO_FILTER_KO: IFilter[] = [
  {
    id: APPLICATION_STATUS_ID.STATUS_NEW,
    label: APPLICATION_STATUS.STATUS_NEW,
    value: APPLICATION_STATUS_VALUE_FILTER.NEW,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_REJECTED,
    label: APPLICATION_STATUS.STATUS_REJECTED,
    value: APPLICATION_STATUS_VALUE_FILTER.REJECTED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_AWAITING_ISSUANCE,
    label: APPLICATION_STATUS.STATUS_AWAITING_ISSUANCE,
    value: APPLICATION_STATUS_VALUE_FILTER.AWAITING_ISSUE,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PROPOSAL,
    label: APPLICATION_STATUS.STATUS_PROPOSAL,
    value: APPLICATION_STATUS_VALUE_FILTER.OFFER,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PAYMENT_REQUIRED,
    label: APPLICATION_STATUS.STATUS_PAYMENT_REQUIRED,
    value: APPLICATION_STATUS_VALUE_FILTER.PAYMENT_REQUIRED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_UNDER_REVIEW,
    label: APPLICATION_STATUS.STATUS_UNDER_REVIEW,
    value: APPLICATION_STATUS_VALUE_FILTER.UNDER_REVIEW,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RETURNED_FOR_REVISION,
    label: APPLICATION_STATUS.STATUS_RETURNED_FOR_REVISION,
    value: APPLICATION_STATUS_VALUE_FILTER.REVISION,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RELEASED,
    label: APPLICATION_STATUS.STATUS_RELEASED,
    value: APPLICATION_STATUS_VALUE_FILTER.ISSUE,
  },
];

export const STATUSES_TO_FILTER_CLIENT: IFilter[] = [
  {
    id: APPLICATION_STATUS_ID.STATUS_SIGNATURE_REQUIRED,
    label: APPLICATION_STATUS.STATUS_SIGNATURE_REQUIRED,
    value: APPLICATION_STATUS_VALUE_FILTER.SIGNATURE_REQUIRED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PAYMENT_REQUIRED,
    label: APPLICATION_STATUS.STATUS_PAYMENT_REQUIRED,
    value: APPLICATION_STATUS_VALUE_FILTER.PAYMENT_REQUIRED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_UNDER_REVIEW,
    label: APPLICATION_STATUS.STATUS_UNDER_REVIEW,
    value: APPLICATION_STATUS_VALUE_FILTER.UNDER_REVIEW,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RETURNED_FOR_REVISION,
    label: APPLICATION_STATUS.STATUS_RETURNED_FOR_REVISION,
    value: APPLICATION_STATUS_VALUE_FILTER.REVISION,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_PROPOSAL,
    label: APPLICATION_STATUS.STATUS_PROPOSAL,
    value: APPLICATION_STATUS_VALUE_FILTER.OFFER,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_REJECTED,
    label: APPLICATION_STATUS.STATUS_REJECTED,
    value: APPLICATION_STATUS_VALUE_FILTER.REJECTED,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_RELEASED,
    label: APPLICATION_STATUS.STATUS_RELEASED,
    value: APPLICATION_STATUS_VALUE_FILTER.ISSUE,
  },
  {
    id: APPLICATION_STATUS_ID.STATUS_AWAITING_ISSUANCE,
    label: APPLICATION_STATUS.STATUS_AWAITING_ISSUANCE,
    value: APPLICATION_STATUS_VALUE_FILTER.AWAITING_ISSUE,
  },
];
